import React from 'react';
import ReportDropDown from 'ui/page/reports/components/reportDropDown.jsx';
import {truBlueStatus} from 'helpers/constants.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class SeasonsUsageOptions extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  componentWillMount() {
    this.resetFilters();
  }

  labelFormat = label => {
    if (label && typeof label === 'string') {
      return 'general.' + label.toLowerCase();
    }

    return '';
  };

  resetFilters = () => {
    let filters = this.props.defaultFilters;

    this.setState({
      branch: filters.branch,
      truBlueStatus: filters.truBlueStatus,
      active: 'all',
    });
  };

  updateData = () => {
    this.props.updateReportData(
      this.state.branch,
      truBlueStatus[this.state.truBlueStatus] === undefined ? '' : truBlueStatus[this.state.truBlueStatus],
    );
  };

  render() {
    let branches = [];
    let truBlue = [];
    let labelFormat = this.labelFormat;
    let {formatMessage} = this.props.intl;
    let {truBlueActive} = this.props;

    const activeStatusOptions = [
      {
        value: 'all',
        label: formatMessage({id: 'general.all'}),
      },
      {
        value: 'active',
        label: formatMessage({id: 'general.active'}),
      },
      {
        value: 'inactive',
        label: formatMessage({id: 'general.inactive'}),
      },
    ];

    if (this.props.branches !== null && this.props.branches.length > 0) {
      branches = Object.keys(this.props.branches).map(key => ({value: this.props.branches[key].id, label: this.props.branches[key].name}));
      branches.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    truBlue = Object.keys(truBlueStatus).map(key =>  ({value: key, label: formatMessage({id: labelFormat(truBlueStatus[key])})}));
    truBlue.unshift({value: 0, label: formatMessage({id: 'general.all'})});

    return <div className='report-options'>
      <div className='top-title-bar'>
        <FormattedMessage id="general.report.options"/>
      </div>
      <div className='select-options container-fluid'>
        <div className='row'>
          <div className='col-sm-3'>
            <ReportDropDown value={this.state.branch}
                            label={formatMessage({id: 'general.store'})}
                            onChange={e => this.setState({branch: e.target.value})}
                            options={branches}/>
          </div>
          {truBlueActive ?
            <div className='col-sm-3'>
              <ReportDropDown value={this.state.truBlueStatus}
                              label={formatMessage({id: 'general.trublue.status'})}
                              onChange={e => this.setState({truBlueStatus: e.target.value})}
                              options={truBlue}/>
            </div> :
            null}
          <div className='col-sm-3'>
            <ReportDropDown onChange={e => this.setState({active: e.target.value})}
                            label={formatMessage({id: 'general.account.status'})}
                            value={this.state.active}
                            options={activeStatusOptions}/>
          </div>
        </div>
      </div>
      <div className='manage-options'>
        <div className='col-sm-12 button-group'>
          <a className='reset-button pull-right'
             onClick={this.resetFilters}><FormattedMessage id="general.reset"/></a>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(SeasonsUsageOptions);
